import { configureStore } from "@reduxjs/toolkit";
import countersSlice from "../reducers/counters";
import textEditorSlice from "../reducers/textEditor";
import searchTopicSlice from "../reducers/searchTopic";
import userSlice from "../reducers/user";
import topicCoverageSlice from "../reducers/topicCoverage";
import titleOptimizationSlice from "../reducers/titleOptimization";
import headingsOptimizationSlice from "../reducers/headingsOptimization";
import topicDensitySlice from "../reducers/topicDensity";
import imagesSlice from "../reducers/images";
import applicationModeSlice from "../reducers/applicationMode";
import categoryTextEditorSlice from "../reducers/categoryTextEditor";
import articleSlice from "../reducers/articles";
import dashboardSlice from "../reducers/dashboard";
import apiErrors from "../reducers/apiErrors";
import confirmationModal from "../reducers/confirmationModal";
import articleSettings from "../reducers/articleSettings";
import contentAuditIssuesSlice from "../reducers/contentAuditIssues";
import keywordsCoverageSlice from "../reducers/keywordsCoverage"

export default configureStore({
  reducer: {
    counters: countersSlice,
    texteditor: textEditorSlice,
    searchtopic: searchTopicSlice,
    user: userSlice,
    topiccoverage: topicCoverageSlice,
    titleoptimization: titleOptimizationSlice,
    headingsoptimization: headingsOptimizationSlice,
    topicdensity: topicDensitySlice,
    images: imagesSlice,
    applicationmode: applicationModeSlice,
    categorytexteditor: categoryTextEditorSlice,
    articles: articleSlice,
    dashboard: dashboardSlice,
    apiErrors,
    confirmationModal,
    articleSettings,
    keywordscoverage: keywordsCoverageSlice,
    contentauditissues: contentAuditIssuesSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
});
